import React, { useState } from "react";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { data } from "../assets/API/data";

function Semisters() {
  const [Ndata] = useState(data);
  const [loader, setLoader] = useState(false);
  const { slug } = useParams();

  const semister = Ndata.find((x) => x.slug === slug);
  if (!semister) {
    setLoader(true);
  }

  const { subjects, heading } = semister;

  return (
    <Wrapper>
      <Herosection title={heading} />
      {loader ? (
        <div>No Data Found</div>
      ) : (
        <div className="allSemWrapper text-center">
          <Container fluid="lg">
            <p className="subHeading fw-bold pt-5 mb-2" data-aos="fade-down">
              Nots
            </p>
            <h2 className="heading fw-bold text-light mt-3" data-aos="fade-up">
              {`${heading} Semester's Subjets Nots`}
            </h2>
            <div className="allCards">
              <Row>
                {subjects.map((item, index) => (
                  <Col
                    md="6"
                    key={item.id}
                    className="gy-4"
                    data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                  >
                    <Card className="text-center p-lg-5 p-4 sem-subjects">
                      <Card.Img
                        className="mb-2"
                        variant="top"
                        src={item.img}
                        alt=""
                      />
                      <Card.Body className="d-flex flex-column justify-content-between">
                        <Card.Title className="text-white mb-3">
                          <h3 className="fw-semibold">{item.name}</h3>
                        </Card.Title>
                        <Row className="gy-3">
                          {item.units.map((item) => (
                            <Col sm={6} lg={4} xs={6}>
                              <Link
                                to={`/notes/${item?.slug}`}
                                state={{ pdf: item?.link }}
                              >
                                <button className="nav-Button py-lg-2 px-lg-4 py-md-2 px-md-3 w-100">
                                  {item.name}
                                </button>
                              </Link>
                            </Col>
                          ))}
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </div>
      )}
    </Wrapper>
  );
}

export default Semisters;
